import { message } from "antd";
import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";

const UserInviteService = {
  sendUserInvitation: async (email) => {
    try {
      const response = await axiosInstance.post(
        API.userInvites.userInvite,
        { email } //  correct payload
      );
      return response.data;
    } catch (error) {
      message.error(error?.response?.data?.details);
      console.error("eoro", error);
      throw error?.response?.data || "Failed to send invite";
     
    }
  },

  // Invite a Finance user (Points 7 & 8). Creates a separate Finance actor.
  sendFinanceInvitation: async (email) => {
    try {
      const response = await axiosInstance.post(API.userInvites.financeInvite, { email });
      return response.data;
    } catch (error) {
      message.error(error?.response?.data?.details);
      console.error("finance invite error", error);
      throw error?.response?.data || "Failed to send finance invite";
    }
  },

  getUserInvitations: async () => {
    try {
      const response = await axiosInstance.get(
        API.userInvites.getInvites
      );
      return response.data;
    } catch (error) {
      throw error?.response?.data || "Failed to fetch invites";
    }
  },
};

export default UserInviteService;